import tIMailData from './TIMailData';

const operations: { [key: string]: any } = {
    TIMailData: tIMailData,
};

export default operations;
